import { BaseStatusDto } from '../baseStatusDto';

export class AuditFormControlTypeDto extends BaseStatusDto {}
